import { createContext } from 'react'

export interface IPwaContext {
  header: {
    display: boolean
    hide: () => void
    show: () => void
  }
  footer: {
    display: boolean
    hide: () => void
    show: () => void
  }
}

export const PwaContext = createContext({} as IPwaContext)
